// @flow
import React, { type Node, useCallback } from 'react'

import DnevnikHome from 'app/components/Apps/Dnevnik/Home'
import StudentsSelector from 'app/components/StudentsSelector'

import {
  dateFormat,
  dnevnikPathMask,
  getDate,
  getStudentIdExact,
  getClassId,
  params as router,
  createPath,
} from 'app/pages/routePaths'

import DnevnikRoot from './DnevnikRoot'
import Nav from './Nav'

type Props = {
  params: Object,
  router: {
    replace: (string) => void,
    push: (string) => void,
  },
}

const DnevnikHomePage = ({ params, router: { replace, push } }: Props): Node => {
  const date = getDate(params)
  const studentID = getStudentIdExact(params)
  const classID = getClassId(params)

  const handleRedirect = useCallback(
    (prms: { +date?: string, +klassId: string }, writeHistory?: boolean = false) => {
      const redirectTo = createPath(
        {
          [router.studentID]: studentID,
          [router.date]: prms.date,
          [router.classID]: prms.klassId,
        },
        dnevnikPathMask,
      )

      if (writeHistory) {
        push(redirectTo)
        return
      }
      replace(redirectTo)
    },
    [studentID, replace, push],
  )

  return (
    <DnevnikRoot studentId={studentID}>
      <Nav studentId={studentID} params={params} />
      <DnevnikHome
        studentId={studentID}
        date={date}
        dateFormat={dateFormat}
        klassId={classID}
        additionalControls={<StudentsSelector />}
        redirect={handleRedirect}
      />
    </DnevnikRoot>
  )
}

export default DnevnikHomePage
